<template>
  <div class="panel-heading">
    <strong>{{title}}</strong>
    <b-tooltip
      label="Edits are not allowed. Change status to Active to edit the form"
      type="is-dark"
      multilined
    >
      <b-icon icon="lock" v-if="editNotAllowed"/>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: 'PanelHeading',
  props: ['title', 'editNotAllowed'],
  data () {
    return {}
  }
}
</script>

<style scoped>
.panel-heading {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
</style>
